export default "__VITE_PUBLIC_ASSET__2abef383__"